import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import PlayerRankingWidget from '../../components/stats/PlayerRankingWidget';
import { getRankingCompetitionMeta, getWidgetConfiguration } from '../../../api';
import { useMemo } from 'react';
import { resolveWidgetDisplayTitle } from '../../utils/widgetDisplayTitle';
//import useViewToken from '../../components/live/hooks/useViewToken';

//   const { token, fetchToken } = useViewToken();

//   useEffect(() => {
//     if (!token) {
//       fetchToken(
//         process.env.REACT_APP_VIEW_CLIENT_ID,
//         process.env.REACT_APP_VIEW_CLIENT_SECRET
//       );
//     }
//   }, [token, fetchToken]);

//   if (!token) return null;

const MAX_SELECTED_COMPETITIONS = 5;

const clampCompetitionIds = (value = '') =>
  String(value || '')
    .split(',')
    .map((id) => id.trim())
    .filter(Boolean)
    .slice(0, MAX_SELECTED_COMPETITIONS);

const clampCompetitionObjects = (value = []) =>
  (Array.isArray(value) ? value : []).slice(0, MAX_SELECTED_COMPETITIONS);

export default function PlayerRankingPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [widgetConfig, setWidgetConfig] = useState(null);

  // const provider = searchParams.get('provider') || '';
  const seasonParam = searchParams.get('season') || '';

  const widgetConfigurationId = searchParams.get('widgetConfigurationId') || '';

  const competitionIdsParam = searchParams.get('competitionIds') || '';

const competitionIds = useMemo(
  () => clampCompetitionIds(competitionIdsParam),
  [competitionIdsParam]
);
  const firstCompetitionId = competitionIds[0];

  const [discipline, setDiscipline] = useState(null);
  const [season, setSeason] = useState(null);
  const [title, setTitle] = useState('Statistiques joueurs');

  useEffect(() => {
    let ignore = false;

    const loadMeta = async () => {
      if (!firstCompetitionId) {
        if (!ignore) {
          setDiscipline(null);
          setSeason(null);
          setTitle('Statistiques joueurs');
        }
        return;
      }

      try {
        const { data } = await getRankingCompetitionMeta(firstCompetitionId);

        if (!ignore) {
          setDiscipline(data?.discipline || null);
          setSeason(data?.season || null);
          setTitle(
            competitionIds.length > 1
              ? 'Statistiques joueurs'
              : data?.name || 'Statistiques joueurs'
          );
        }
      } catch (error) {
        if (!ignore) {
          setDiscipline(null);
          setSeason(null);
          setTitle('Statistiques joueurs');
        }
      }
    };

    loadMeta();

    return () => {
      ignore = true;
    };
  }, [firstCompetitionId, competitionIds.length]);

  useEffect(() => {
  let ignore = false;

  const loadWidgetConfig = async () => {
    if (!widgetConfigurationId) {
      if (!ignore) setWidgetConfig(null);
      return;
    }

    try {
      const { data } = await getWidgetConfiguration(widgetConfigurationId);
      if (!ignore) setWidgetConfig(data || null);
    } catch {
      if (!ignore) setWidgetConfig(null);
    }
  };

  loadWidgetConfig();

  return () => {
    ignore = true;
  };
}, [widgetConfigurationId]);

const competitionInfos = useMemo(
  () =>
    competitionIds.length === 1 && title && title !== 'Statistiques joueurs'
      ? [{ name: title }]
      : [],
  [competitionIds.length, title]
);

const resolvedTitle = useMemo(
  () =>
    resolveWidgetDisplayTitle({
      widgetConfig,
      competitionInfos,
      fallbackTitle: title,
    }),
  [widgetConfig, competitionInfos, title]
);

const shouldShowWidgetHeader = Boolean(resolvedTitle);

  if (!discipline || competitionIds.length === 0) return null;

  return (
    <PlayerRankingWidget
      discipline={discipline}
      season={seasonParam || null}
      competitionIds={competitionIds}
      widgetConfigurationId={widgetConfigurationId || null}
      title={resolvedTitle}
      showCompetitionInfos={shouldShowWidgetHeader}
      onNavigate={(url) => navigate(url)}
    />
  );
}